import {RegionModel} from './RegionModel';

export class LocalCustomerModel {
  id?: number;
  regionCod: string;
  cod: string;
  region?: RegionModel;
  description?: any;
  checked?: boolean;

  constructor(id?: number, regionCod?: string, cod?: string, region?: RegionModel, description?: any, checked?: boolean) {
    this.id = id;
    this.regionCod = regionCod;
    this.cod = cod;
    this.region = region;
    this.description = description;
    this.checked = checked;
  }
}
